export default {
  categoryInfo: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        'Her şeyden önce, sağlık!',
        'Tamamlayıcı sağlık sigortası, özel hastanelere cepten yapılan harcamaları azaltmanın ve sağlık hizmeti kullanımını artırmanın bir yoludur. ',
        'Tamamlayıcı sağlık sigortası, Sosyal Güvenlik Kurumu (SGK) kapsamında yer alan kişilerin sağlığını güvence alına alarak, anlaşmalı özel hastanelerden fark ücreti ödemeden faydalanmasına imkân sağlayan sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: 'Tamamlayıcı Sağlık Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph: 'Herhangi bir hastane ziyareti endişe verici olabilir. Tamamlayıcı sağlık sigortası, saf konforun yanı sıra, konaklamanızla ilgili en önemli sorulardan bazılarını rahatlatmanıza yardımcı olur: Cerrahım kim olacak? Benimle kim ilgilenecek? Ne zaman ve nerede ameliyat edileceğim? Muayene için hangi hastaneye gitmeliyim? Gibi sorulara tamamlayıcı sağlık sigortası olmadan cevap vermek zordur. ',
          subList: null
        },
        {
          paragraph: 'SGK fark ücretini ödemeden hastaneye yatış çözümleri size en iyi doktorlara, en iyi hastanelere ve desteğe erişim sağlar.',
          subList: null
        },
        {
          paragraph: 'Alternatif tedaviler ile hastalık sorunlarınıza hızlı çözüm sunar.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        company: require('@/assets/company-logos/ak-sigorta.jpg'),
        alt: 'Ak Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Geniş Asistans Hizmeti',
        desc: 'Farklı Network Seçenekleri'
      },
      {
        id: 2,
        company: require('@/assets/company-logos/mapfre-sigorta.png'),
        alt: 'Mapfre Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Avantajlı İndirim',
        desc: 'Fark Ücretine Son'
      },
      {
        id: 3,
        company: require('@/assets/company-logos/sompo-sigorta.png'),
        alt: 'Sompo Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Hizmetli',
        desc: 'Covid 19 Teminatlı'
      },
      {
        id: 4,
        company: require('@/assets/company-logos/demir-sigorta.png'),
        alt: 'Demir Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: '9 Farklı Plan',
        desc: '3 Farklı Anlaşmalı Kurum Ağı'
      },
      {
        id: 5,
        company: require('@/assets/company-logos/hdi-sigorta.jpg'),
        alt: 'HDI Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Geniş Kapsamlı',
        desc: 'Özel İndirimli Fiyat'
      },
      {
        id: 6,
        company: require('@/assets/company-logos/allianz-sigorta.jpg'),
        alt: 'Allianz Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        desc: 'Farklı Network Seçenekleri'
      }
    ]
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Tamamlayıcı Sağlık Sigortası Şartları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası yaptırmak isteyen adayların SGK kapsamında olması şarttır.',
          subList: null
        },
        {
          paragraph:
            'Bunun dışında aranan diğer şart ise sigorta şirketlerinin yaş standartlarına uyum sağlamasıdır.',
          subList: null
        },
        {
          paragraph:
            'SGK’sı bulunan ve yaş sınırlarına uyan her aday tamamlayıcı sağlık sigortası yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Genel Şartları Neden Önemlidir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası fiyatlarını araştırırken karşınıza çıkacak önemli bir konuda “genel ve özel şartlar“ olmaktadır. Sağlık sigortası kapsamında sunulan ürünlerde diğer ürünler gibi genel şartlar bakımından sabittir. Yani genel şartlar sigorta şirketlerine göre farklılık göstermemektedir.',
          subList: null
        },
        {
          paragraph:
            'Özel şartlar ise sigorta şirketlerine göre farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası fiyatlarını araştırırken genel şartlar hakkında bilgi aldığınız gibi özel şartlar hakkında da bilgi almalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında <strong><em><u>yatarak tedavi teminatı</u></em></strong> ve <strong><em><u>ayakta tedavi teminatı</u></em></strong>  bulunmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Bu doğrultuda tamamlayıcı sağlık sigortası; doktor hizmetlerini, yatan ve ayakta hasta hastane bakımı, hamilelik ve doğum gibi daha fazla durumu kapsar.',
          subList: null
        },
        {
          paragraph:
            'Her planın karşıladığı durumlar aynı değildir. Bazı planlar daha fazla hizmeti kapsar. Planlar, çocuklar için de sunulmaktadır. Kendi sağlığınızı koruma altına almak yerine aile sağlık planları değerlendirerek, geniş kapsamlı teminatlardan da yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Yatarak Tedavi Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Yatarak tedavi teminatı, tamamlayıcı sağlık sigortası kapsamında sigorta şirketlerinin anlaşmalı olduğu özel hastanelerden alınan hizmet sonucunda doktorun yatış gerektirdiğini ifade ettiği ve 24 saati geçen işlemler için güvence sağlayan teminattır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Ayakta Tedavi Teminatı Nedir?',
      content: [
        {
          paragraph:
            '24 saati aşmayan tedaviler için güvence sağlayan teminattır.',
          subList: null
        },
        {
          paragraph:
            'Ayakta Tedavi Teminatı için poliçe kapsamında belirlenen muayene adetleri 6, 8 ve 10 şeklinde kullanım hakkı ile sunulmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasından SGK’sı aktif olan kişiler yararlanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası için belirlenmiş olan yaş sınırları sigorta şirketlerine göre farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Üst yaş sınır çoğu sigorta şirketinde 55 iken bazı sigorta şirketlerinde 64 olabilmektedir. Bunların dışında sadece bir sigorta şirketinde 80’dir.',
          subList: null
        },
        {
          paragraph:
            'Yaş ilerledikçe tamamlayıcı sağlık sigortası fiyatları artar. Bu sebeple sağlık sigortası yaptırmak için en ideal zaman şimdi!',
          subList: null
        }
      ]
    },
    {
      title:
        '65 Yaş Üstü Tamamlayıcı Sağlık Sigortası Yapan Şirketler Hangileridir?',
      content: [
        {
          paragraph:
            '65 yaş üstü tamamlayıcı sağlık sigortası yaptırmak isteyenlere özel 1 şirket bazında fiyat teklifi sunabiliriz.',
          subList: null
        },
        {
          paragraph:
            'Türk Nippon Sigorta’nın 80 yaşa kadar olanak sağladığı sigorta poliçesini şartlarınıza uyması sonucunda alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Hangi Hastanelerde Geçerli?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası anlaşmalı hastaneler sigorta şirketlerine göre farklılık göstermektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Anlaşmalı Hastaneler Nedir?',
      content: [
        {
          paragraph:
            'Genel olarak tamamlayıcı sağlık sigortasının geçtiği hastaneler; Medicana, Medical Park, Medipol ve Kolan Hastaneleridir. Sigorta şirketleri bazında anlaşmalı hastaneleri incelemek için teklif alabilir, uzmanlarımızla görüşebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası İle Tamamlayıcı Sağlık Sigortası Arasındaki Fark Nedir?',
      content: [
        {
          paragraph:
            'Genel olarak tamamlayıcı sağlık sigortasının geçtiği hastaneler; Medicana, Medical Park, Medipol ve Kolan Hastaneleridir. Sigorta şirketleri bazında anlaşmalı hastaneleri incelemek için teklif alabilir, uzmanlarımızla görüşebilirsiniz.',
          subList: [
            'Tamamlayıcı sağlık sigortası yaptırmak isteyen adaylarda aranan şartın başında SGK’lı olması gelirken, özel sağlık sigortasında böyle bir durum söz konusu değildir.',
            'Tamamlayıcı sağlık sigortası prim ödemeleri özel sağlık sigortası ücretlerine göre daha düşüktür.',
            'Özel sağlık sigortasının kapsamı tamamlayıcı sağlık sigortası kapsamına göre daha geniştir.',
            'Özel sağlık sigortasında bulunan yurt dışı teminatı sayesinde ülke dışında da sağlık hizmeti alınabilir. Fakat tamamlayıcı sağlık sigortası yurt içinde geçerlidir.',
            'Tamamlayıcı sağlık sigortasında sadece anlaşmalı hastanelerden hizmet alabilirsiniz. Fakat özel sağlık sigortasında anlaşmalı olmayan özel hastanelerden de hizmet alabilirsiniz. Bu tamamen sigorta şirketiniz ile alakalıdır.',
            'Tamamlayıcı sağlık sigortasında katılım payı oranı bulunmamaktadır. Hastane masraflarını SGK ile sigorta şirketi ödemektedir. Poliçe sahibi sadece katılım payını öder.',
            'Özel sağlık sigortasında ise katılım payı oranı bulunmaktadır. Katılım payı oranı sigortalı seçeneğine göre farklılık değişmektedir. Kısacası poliçe sahibi hastane ücretinin bir kısmını kendisi ödemektedir.'
          ]
        }
      ]
    },
    {
      title: 'Aile Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bir aile sağlık sigortası planını, yalnızca bakmakla yükümlü olduğunuz kişilerin poliçeye eklediği bireysel bir plan olarak düşünün. Aile sağlık sigortası planı, bir aileden en az 2 kişinin katıldığı sigort poliçesidir. Kapsam için alışveriş yaptığınızda, bireysel kapsam için alışveriş yapmaktan daha fazlasını dikkate almanız gerekir. Düşük primli ve yüksek indirilebilir bir plan ilk bakışta çekici görünse de, çocuklarınız veya bakmakla yükümlü olduğunuz diğer kişiler için sağlık sigortası satın aldığınızı göz önünde bulundurmalısınız.',
          subList: null
        },
        {
          paragraph:
            'Çocuklar için sağlık sigortası satın almaya gelince, daha yüksek bir aylık primi ve daha düşük bir muafiyeti olan bir aile planı aramayı düşünebilirsiniz, çünkü birkaç kişinin sağlık bakımı ihtiyaçlarınız tek bir plan kapsamında karşılanmaktadır. Dört kişilik bir aileden daha büyük bir aileniz varsa, sigortanızın genel olarak daha pahalı olmasını bekleyebilirsiniz, ancak sonunda kişi başına daha az ödeme yapmanız gerekebilir.',
          subList: null
        },
        {
          paragraph:
            'Ailenizin sağlığı iyiyse, kişi başına daha az ödeme yapmanız da muhtemeldir. Bu durumda, ailenizi sağlıklı tutmak ve uzun vadede maliyetleri düşürmek için önleyici bakımı kapsayan bir sigorta poliçesi almak akıllıca olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Yapan Şirketler Hangileri?',
      content: [
        {
          paragraph:
            'Alokasko.com üzerinden talep edeceğiniz tamamlayıcı sağlık sigortası kapsamında fiyat sunabileceğimiz anlaşmalı sigorta şirketlerimiz:',
          subList: [
            'Ak Sigorta',
            'Allianz Sigorta',
            'Ankara Sigorta',
            'Demir Hayat',
            'Ethica',
            'Groupama Sigorta',
            'HDI Sigorta',
            'Mapfre Sigorta',
            'Ray Sigorta',
            'Sompo Sigorta',
            'Türk Nippon Sigorta',
            'Türkiye Sigorta'
          ]
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası poliçesi satın aldığınızda ve priminizi ödediğinizde başlasa da bazı teminatlardan yararlanabilmeniz için 3 ay bekleme süresi bulunur. Bu sebeple poliçenizi onaylamadan önce mutlaka bekleme süreleri hakkında kapsamlı bilgi almalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Yeni Doğan Bebeğe Sağlık Sigortası Yapılır Mı?',
      content: [
        {
          paragraph:
            'Yeni doğan bebeğinizi dünyaya geldiği andan itibaren güvence altına almak isteyebilirsiniz. Bebek için sağlık sigortası yaptırdığınızda bebeğiniz doğduğu andan itibaren sigortalı olur.',
          subList: null
        }
      ]
    },
    {
      title: 'Bebekler İçin Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bebek tamamlayıcı sağlık sigortası, yeni doğan bebekler için yapılan sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Poliçe Süresi Ne Kadardır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası ürünü 1 yıllık yapılan sigorta poliçesidir. Satın aldığınız tarihten itibaren bir yıl geçerli olan poliçeniz ile sigorta şirketinin anlaşmalı olduğu özel hastanelerden fark ücreti ödemeden yararlanabilmenizi sağlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Bekleme Süresi Nedir?',
      content: [
        {
          paragraph:
            'Sağlık sigortasında yer alan bekleme süresi kısacası takip süresidir. Sigorta şirketi size özel sunacağı poliçe kapsamında sağlık durumunu değerlendirerek riskleri güvence altına alabilmesi adına bazı teminatlara bekleme süresi ekler.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında belirtilen bekleme süresi dolmadan o teminattan yararlanamazsınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Ömür Boyu Yenileme Garantisi Nedir?',
      content: [
        {
          paragraph:
            'Ömür boyu yenileme garantisi, sigorta şirketlerinin sigortalılarına sunmuş olduğu bir avantajdır. Sigorta şirketleri sağlık sigortası poliçelerini düzenli yenileyen sigortalılarına yapacağı risk değerlendirmesi sonucunda “<strong><em><u>ömür boyu yenileme garantisi</u></em></strong>” verir.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası ile ömür boyu yenileme garantisi alabilmeniz için poliçenizi aynı şirketten 3 ila 4 yıl arası düzenli olarak yenilemeniz gerekir. Sigorta şirketlerinin belirlemiş olduğu ömür boyu yenileme süreleri farklılık göstermektedir. Bu sebeple poliçenizi onaylamadan önce şirketin ömür boyu yenileme sunup sunmadığını hakkında bilgi almalısınız.',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortasında İlaç Masrafları Poliçe Kapsamında Ödenir Mi?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında ilaç giderlerinin karşılanıp karşılanmadığı merak edilen konuların başında gelmektedir.',
          subList: null
        },
        {
          paragraph:
            'İlaç giderleri tamamlayıcı sağlık sigortasından karşılanmaz, kapsam dışı sayılır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası İçin Katılım Payı Ödüyor Muyum?',
      content: [
        {
          paragraph:
            'Evet, tamamlayıcı sağlık sigortası kapsamında özel hastaneden alacağınız işlemlerinizde sadece 15 TL’lik bir katılım ücreti ödersiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Örneğin;</u></em></strong> özel hastaneden aldığınız bir sağlık hizmetinin muayene ücreti 700 TL tuttu. Bu tutarın 200 TL’si SGK tarafından karşılanıyorsa 500 TL’si tamamlayıcı sağlık sigortası kapsamında sigorta şirketiniz öder. Siz sadece 15 TL’lik bir katılım ücreti öderseniz.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası hem maddi hem de manevi olarak size kolaylık sağlar!',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Poliçem Yurt Dışında Geçerli Mi?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında yurt dışı teminatı bulunmamaktadır. Sağlık sigortanızı yurt dışında da kullanmak istiyorsanız, özel sağlık sigortası yaptırmayı düşünebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası poliçenizi kullanabilmeniz için öncelikle primlerinizi düzenli ödemeniz gerekir. Primlerinizi düzenli ödememeniz durumunda poliçeniz pasif hale gelir ve kullanamazsınız.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası poliçeniz aldıktan hemen sonra kullanmak istiyorsanız, mutlaka bekleme sürelerini göz önünde bulundurmalısınız.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasını kullanabilmeniz için ilk yapmanız gereken sigorta şirketinizin anlaşmalı hastanesinden randevu almanızdır.',
          subList: null
        },
        {
          paragraph:
            'İlgili bölümden aldığınız randevunuz için hastaneye giderek, tamamlayıcı sağlık sigortanızın olduğunu belirtmeniz yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kullanmanız durumunda anlaşmalı özel hastaneye sadece katılım payı ücreti ödersiniz. Yapılan işlemden geriye kalan tüm masrafları sigorta şirketiniz %100 karşılar.',
          subList: null
        },
        {
          paragraph: 'Özel sağlık sigortası fiyatlarına göre daha uygundur.',
          subList: null
        }
      ]
    },
    {
      title: 'Hamilelikte Tamamlayıcı Sağlık Sigortası Yapılır Mı?',
      content: [
        {
          paragraph:
            'Hamileyken tamamlayıcı sağlık sigortası yaptırabilirsiniz. Bekleme süresiz doğum sigortası olarak hamile anne adaylarına sunulan bu poliçe 9. Aya kadar alınabilmektedir.',
          subList: null
        },
        {
          paragraph:
            'Hamileyken yaptırılabilen doğum sigortası her sigorta şirketinde yoktur. Bu sebeple karşılaştırma yapmak için uzmanlarımızla görüşme sağlayabilirsiniz.            ',
          subList: null
        },
        {
          paragraph:
            'Hamileyseniz ve sağlık sigortası yaptırmak istiyorsanız başvuru formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Hamilelik Döneminde Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Hamilelik döneminde doğum sigortası yaptırmak için fiyat teklifinde bulunmanız gerekmektedir.',
          subList: null
        },
        {
          paragraph:
            'Fiyat teklif formunda sizden istenilen bilgileri doğru girmemiz sonucunda en uygun planlar sizin için hazırlanır. Uzmanlarımız ile birlikte karşılaştırma',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortası Geçmişten Gelen Hastalıkları Öder Mi?',
      content: [
        {
          paragraph:
            'Sağlık sigortası geçmişten gelen hastalıklara karşı güvence sağlamaz. Poliçe başlangıç tarihinden önce var olan hastalığınız tamamlayıcı sağlık sigortası tarafından karşılanmamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortanızı ne kadar erken yaşta alırsanız o kadar avantajlı teminatlardan yararlanırsınız. Bu sebeple sağlık durumunuz iyiyken güvencenizi başlatın, olası sağlık risklerinde masrafları düşünmeyin!',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Doğum Paketi Nedir?          ',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası doğum paketi; anne adayının doğum sürecini güvence altına alarak, özel hastanelerde doğum sürecindeki masrafları karşılar.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında doğum teminatı ek teminat olarak satılmaktadır. Hamilelik planlayan anne adayları ek teminatlar arasından poliçelerine doğum teminatı ekleyerek, gerekli bekleme süresini tamamladıktan sonra bu teminattan yararlanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Tüp Bebeği Karşılar Mı?        ',
      content: [
        {
          paragraph:
            'Tüp bebek teminatı sağlayan sadece 1 sigorta şirketi bulunmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında tüp bebek teminatı sunan sigorta şirketi Anadolu Sigorta’dır.',
          subList: null
        },
        {
          paragraph:
            'Anadolu Sigorta’dan bu teminatı alabilmeniz için devlet hastanelerinden normal yolla gebe kalamadığınıza dair bir yazı iletmeniz istenir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Diş Tedavisini Karşılar Mı?',
      content: [
        {
          paragraph:
            'Diş tedavisi tamamlayıcı sağlık sigortasının ana teminatları arasında yer almaktadır. Yani sigorta poliçenizi satın aldığınız zaman diş teminatı bulunmuyorsa diş tedavileriniz karşılanmaz.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında bazı sigorta şirketleri sigortalılarına diş paketi sunabilir. Poliçenizde hizmetler bölümünde diş paketi yer alıyorsa, faydalanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Sünneti Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında sünnet teminatı veren tek şirket Anadolu Sigorta’dır.',
          subList: null
        },
        {
          paragraph:
            'Sünnet masraflarının sağlık sigortası poliçesinden karşılanmasını isteyen adaylar Anadolu Sigorta’nın fiyatlarını inceleyebilir. Sünnet teminatını poliçenize eklettiğiniz süreden sonra 1 yıl bekleme süresi bulunmaktadır. Bu teminattan yararlanabilmeniz için bekleme süresini tamamlamalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Check Up Paketi Nedir?',
      content: [
        {
          paragraph:
            'Sağlık sigortasında bulunan check-up teminatı kapsamı sigorta şirketlerine ve planlara göre farklılık göstermektedir. Her planda bulunmayabilir.',
          subList: null
        },
        {
          paragraph: 'Genel olarak check-up içeriğinde:',
          subList: [
            'Açlık Kan Şekeri',
            'Akciğer grafisi (Tek Yönlü)',
            'CRP (C-reaktif protein)',
            'Dahiliye Muayene',
            'EKG (Elektrokardiyografi)',
            'Hemogram (18 parametre)',
            'İdrar Tahlili',
            'Kreatinin',
            'LDL Kolesterol (Düşük Yoğunluklu Lipoprotein)',
            'RF (Romatoid Faktör – Kan Testi)',
            'SGOT& SGPT (Karaciğer Fonksiyon Testleri)',
            'Total Kolesterol Testi karşılanır.'
          ]
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Mr Karşılar Mı?',
      content: [
        {
          paragraph: 'Mr ayakta tedavi teminatı kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Psikiyatri Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında psikiyatri giderleri karşılanmamaktadır. Özellikle ana teminat olarak poliçeye alınan bir teminat değildir. Fakat bazı sigorta şirketleri, sigortalılarına psikolojik destek hizmeti sunabiliyor.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Göz Paketi Nedir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında bulunan teminatlar göz muayenelerinin ya da göz ameliyatlarının karşılanıp karşılanmayacağını belirler. Bu noktada en önemli durum sigorta şirketinin anlaşmalı olduğu göz hastanesi olup olmadığıdır.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası göz paketi ile göz muayenesi ve sigorta poliçenizi başlattığınız andan sonra ortaya çıkabilecek ve SGK’nın da onayladığı göz ameliyatlarını karşılanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Burun Ameliyatını Karşılar Mı?',
      content: [
        {
          paragraph: null,
          subList: [
            'Her türlü estetik ve kozmetik amaçlı girişimler,',
            'Plastik cerrahi,',
            'Burun küçültme,',
            'Yağ aldırma gibi estetik amaçlı olan tüm cerrahi girişimler teminat kapsamı dışındadır.'
          ]
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Fiyatları Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası, özel sağlık sigortası çeşitleri arasında yer almaktadır. Bu doğrultu da sigorta ücretleri sigorta şirketlerinin teminatlarına, limitlerine ve ek hizmetlerine değişkenlik gösterecektir.',
          subList: null
        },
        {
          paragraph:
            'En doğru tamamlayıcı sağlık sigortası fiyatlarına ulaşmak için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası hesaplaması, sigorta şirketlerinin ekranları üzerinde yapılır. Sizden alınan bilgiler gizlilik çerçevesinde tutulur ve fiyat çalışmanız hazırlanır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortası Ücretleri Neye Göre Belirlenir?        ',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası ücretleri hesaplanırken en önemli kriter yaştır. Adayın yaşı, sağlık durumunu ve sağlık risklerini belirler.',
          subList: null
        },
        {
          paragraph:
            'Bunun dışında tercih edeceğiniz sağlık planı, sigorta teminatları, teminat limitleri, bulunduğunuz konum gibi durumlarda primlerin hesaplanmasında aktif rol oynar.',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortası Vergi İndirimi Nasıl Kullanılır?          ',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında vergi indirim avantajı, maaşın brüt miktarının %15 i kadar olmalıdır. Bunun dışında asgari ücretin yıllık tutarını da aşmamalıdır.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortasında vergi indiriminden yararlanmak isteyen kişiler muhasebecisi ile görüşme sağlamalıdır.  İlgili poliçesini muhasebeye iletmesi durumunda vergi indirimi ile işlemlerinizi başlatacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Sorgulama Nasıl Yapılır?          ',
      content: [
        {
          paragraph:
            'Mevcut sağlık sigortası poliçenizi sorgulamak için sigorta şirketinizin resmi web sitesini ziyaret ederek online işlemler menüsüne giriş yapabilirsiniz. Giriş adımlarını takip ederek aktif poliçenize ulaşabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Yeni tamamlayıcı sağlık sigortası fiyatı sorgulamak isteyen müşterilerimiz başvuru formumuzu doldurarak sağlık danışmanlarımızdan destek alabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'En Ucuz Tamamlayıcı Sağlık Sigortası Alınır Mı?',
      content: [
        {
          paragraph:
            'En ucuz tamamlayıcı sağlık sigortası fiyatını sunan sigorta şirketini elbette seçebilirsiniz. Hangi fiyatı ve hangi şirketi seçeceğiniz tamamen size bağlıdır. Fakat bu nokta da değerlendirmeniz gereken en önemli şey teklif detayına eklenen teminatlar ve hangi hastanelerde ne kadar limitle yararlanabildiğinizdir. Bu durumları değerlendirmeden en ucuz sağlık sigortasını tercih ederseniz hizmet alma aşamasında sıkıntı yaşayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'En Uygun Tamamlayıcı Sağlık Sigortası Hangisidir?        ',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası fiyatları yaşa bağlı değişkenlik göstermektedir. Yaşla birlikte adayın sağlık durumu da poliçe ücretlerinin belirlenmesini sağlar.',
          subList: null
        },
        {
          paragraph:
            'Her adayın sağlık durumu ve sağlık ihtiyaçları bir değildir. Bu sebeple tamamlayıcı sağlık sigortası kapsamında size sunulacak teklifler, size özel hazırlanacaktır. En uygun poliçenin yanı sıra en iyi sağlık sigortasını tercih etmek için sağlık uzmanlarımızdan hemen fiyat teklifi isteyin.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Tamamlayıcı Sağlık Sigortası Hangisi?        ',
      content: [
        {
          paragraph:
            'En iyi tamamlayıcı sağlık sigortası kavramı sigortalının her ihtiyacına çözüm sunan, talep ettiği tüm tedavileri karşılayan sigorta poliçesidir. Sigorta şirketleri arasında en iyi şirket budur, gibi bir şey söylenememekle birlikte en iyi şirket kişiden kişiye değiştiği gibi planlarda değişiklik gösterecektir.',
          subList: null
        },
        {
          paragraph:
            'Sizin için en iyi tamamlayıcı sağlık sigortasını sigorta uzmanlarımızdan destek alarak hemen oluşturabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortası Karşılaştırma Nasıl Yapılır?        ',
      content: [
        {
          paragraph:
            'Sağlık sigortası satın almak kolay bir iş gibi görünse de karmaşık olabilmektedir. Sigorta şirketlerinin sunmuş olduğu teminatlar ve limitler birbirinden farklıdır. Bu sebeple mutlaka şirketler arası karşılaştırma yapmalısınız.',
          subList: null
        },
        {
          paragraph:
            'Temelde 2 tür sağlık sigortası vardır: Özel Sağlık Sigortası ve Tamamlayıcı Sağlık Sigortası.',
          subList: null
        },
        {
          paragraph:
            'SGK kapsamında tamamlayıcı sağlık sigortası karşılaştırması yapmak için başvuru formunda sizden istenilen bilgileri doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İnternetten Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Bazı basit adımlarla, maliyetleri nasıl kontrol edeceğinizi öğrenebilir ve bazı büyük avantajlardan yararlanmaya devam edebilirsiniz! Yani, daha fazlasını öğrenmek ister misiniz?',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası hakkında daha fazla bilgi için sağlık uzmanlarımız burada!',
          subList: null
        },
        {
          paragraph: 'Teklif almak için hemen teklif formunu doldurun.',
          subList: null
        }
      ]
    }
  ]
}
